module.exports = __webpack_public_path__ + "static/media/youtube.0e10c60b.svg";